import "./CustomTable.css";
import "./CustomTableWithEditDeleteCol.css";
import { useCallback, useContext, useMemo } from "react";
import { IonButton } from "@ionic/react";
import sortUpImg from "../assets/images/Button_Sort_Up.png";
import sortDownImg from "../assets/images/Button_Sort_Down.png";
import { Column, useSortBy, useTable } from "react-table";
import AppContext from "../providers/AppContext";
import { FixedSizeList as List} from "react-window";

const CustomTableWithEditDeleteCol = ({
  cols, 
  rowData,
  handleEditItem,
  handleDeleteItem,
}: {
  cols: any[];
  rowData: any[];
  handleEditItem: (item: any) => void;
  handleDeleteItem: (item: any) => void;
}) => {
  const appContext = useContext(AppContext);

  const columns = useMemo(() => {
    const extraCol: Column = {
      maxWidth: 300,
      id: "editDeleteCol",
      disableSortBy: true,
      Cell: (props: any) => {
        const itemClickedId = props.row.original.id;
        return (
          <div id="columnBtnsContainer">
            <IonButton
              id="editBtn"
              type="button"
              onClick={() => {
                const itemToEdit = props.data.find((item: any) => item.id === itemClickedId);
                handleEditItem(itemToEdit!);
              }}
            >
              Edit
            </IonButton>
            <p>|</p>
            <IonButton
              disabled={
                // disable button so that user can't delete themself
                props.data.find((item: any) => item.id === itemClickedId).email === appContext.currentUser?.email
              }
              id="deleteBtn"
              type="button"
              onClick={() => {
                const itemToDelete = props.data.find((item: any) => item.id === itemClickedId);
                handleDeleteItem(itemToDelete!);
              }}
            >
              Delete
            </IonButton>
          </div>
        );
      },
    };
    return [
      ...cols,
      // add edit/delete column
      extraCol,
    ];
  }, []);

  const defaultColumn: any = useMemo(() => ({}), []);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns: columns,
      data: rowData,
      defaultColumn: defaultColumn,
    },
    useSortBy
  );

  const RenderRow = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const row = rows[index];
      prepareRow(row);
      return (
        <div
          {...row.getRowProps({
            style,
          })}
          className="tableRow"
        >
          {row.cells.map((cell, index) => {
            return (
              <div
                {...cell.getCellProps(props => [props, { style: { flex: 1, maxWidth: cell.column.maxWidth } }])}
                className="tableCell"
              >
                {cell.render("Cell")}
              </div>
            );
          })}
        </div>
      );
    },
    [prepareRow, rows]
  );

  return (
    <div id="tableContainer">
      <div {...getTableProps()} className="table">
        {/* header */}
        <div>
          {headerGroups.map(headerGroup => (
            <div
              {...headerGroup.getHeaderGroupProps()}
              className="tableHeadersContainer"
              style={{ paddingRight: rowData.length > 5 ? "10px" : "0px" }}
            >
              {headerGroup.headers.map(column => (
                <div
                  {...column.getHeaderProps(props => [
                    column.getSortByToggleProps(),
                    { style: { flex: 1, maxWidth: column.maxWidth } },
                  ])}
                  className={column.id === "editDeleteCol" ? "tableHeader" : "sortableHeader tableHeader"}
                >
                  {column.render("Header")}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <img src={sortDownImg} width="35px" height="35px" />
                    ) : (
                      <img src={sortUpImg} width="35px" height="35px" />
                    )
                  ) : null}
                </div>
              ))}
            </div>
          ))}
        </div>
        {/* body */}
        <div {...getTableBodyProps()} className="body">
          <List
            className="virtualizedList"
            height={425}
            itemCount={rows.length}
            itemSize={85} // row height
            width={"100%"}
            // itemKey={(item, index) => {
            //   return rows[index].id;
            // }}
          >
            {RenderRow}
          </List>
        </div>
      </div>
    </div>
  );
};

export default CustomTableWithEditDeleteCol;
